import { useEffect } from 'react';

/**
 * Componente para agregar meta tags SEO dinámicamente
 * Usado principalmente para bloquear indexación de rutas privadas
 */
const SEOHead = ({ 
  title = 'Numerathum - Mi Brújula del Tiempo',
  description = 'Descubre tu energía personal con Numerathum',
  noindex = false 
}) => {
  useEffect(() => {
    // Actualizar título
    document.title = title;
    
    // Actualizar o crear meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);
    
    // Actualizar o crear meta robots
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    
    if (noindex) {
      metaRobots.setAttribute('content', 'noindex, nofollow');
    } else {
      metaRobots.setAttribute('content', 'index, follow');
    }
    
    // Actualizar Open Graph image con dimensiones correctas
    const updateOrCreateMeta = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };
    
    updateOrCreateMeta('og:image', 'https://numerathum.numerologia-cotidiana.com/Numerathum.png');
    updateOrCreateMeta('og:image:width', '1480');
    updateOrCreateMeta('og:image:height', '742');
    updateOrCreateMeta('og:image:alt', 'Numerathum - Mi Brújula del Tiempo');
  }, [title, description, noindex]);

  return null; // Este componente no renderiza nada
};

export default SEOHead;

